// extracted by mini-css-extract-plugin
export var actionIcon = "_ru-0";